import { render, staticRenderFns } from "./PricingTableDesktopDetail.vue?vue&type=template&id=1648611c&scoped=true&"
import script from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js&"
export * from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js&"
import style0 from "./PricingTableDesktopDetail.vue?vue&type=style&index=0&id=1648611c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648611c",
  null
  
)

export default component.exports